import QuillDelta from 'quill-delta';

import QuillEditor from './QuillEditor';

export default function QuillText(props: { quill: any; placeholder?: string }) {
	const text = props.quill?.ops.map((op: { insert?: string }) => op.insert ?? '').join('');

	if (props.placeholder && !text?.length) {
		return <>{props.placeholder}</>;
	} else {
		return <QuillEditor inline readOnly value={props.quill ?? new QuillDelta()} />;
	}
}
